import { render, staticRenderFns } from "./newRepair.vue?vue&type=template&id=6d374d99&scoped=true&"
import script from "./newRepair.vue?vue&type=script&lang=js&"
export * from "./newRepair.vue?vue&type=script&lang=js&"
import style0 from "./newRepair.vue?vue&type=style&index=0&id=6d374d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d374d99",
  null
  
)

export default component.exports